import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { FaEdit, FaBars, FaTrash } from 'react-icons/fa';
import { Switch } from 'pretty-checkbox-react';
import Swal from 'sweetalert2';
import 'pretty-checkbox';

import { deleteBundle } from 'redux/actions';

import Paths from 'paths';

class Bundle extends Component{

    render() {
        return (
            <div className={'soundbox-grid-bar'}>
                <div className={'soundbox-grid-bar-handle'}><FaBars /></div>
                <div className={'soundbox-grid-bar-id'}>
                    <span>{this.props.bundle.id}</span>
                </div>
                <div className={'soundbox-grid-bar-title'}>
                    <span>{this.props.bundle.title}</span>
                </div>
                <div className={'soundbox-grid-bar-active'}>
                    <Switch shape={'fill'} locked={true} color={'danger'} checked={true} onChange={() => {}}></Switch>
                </div>
                <NavLink className={'soundbox-grid-bar-edit'} to={Paths.PATH_ADMIN_EDIT_BUNDLES.replace(':bundleId',this.props.bundle.id)}><FaEdit /></NavLink>
                <div className={'soundbox-grid-bar-delete'} onClick={() => this.aprooveDelete(this.props.bundle)}><FaTrash /></div>
            </div>
        )
    }

    aprooveDelete = (bundle) => {
        Swal.fire({
            title: `Suppression du bundle ${bundle.id}`,
            text: 'Etes vous vraiment sûr ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui !'
        }).then((result) => {
            if (result.value) {
                this.props.deleteBundle(bundle.id);
            }
        })
    }
}

const mapDispatchToProps = { deleteBundle };

export default connect(null, mapDispatchToProps)(Bundle);
